<template>
	<div class="myOrderContainer">
		<div class="msg-center-nav">
			<div class="msg-categories">
				<div v-for="category in categories" :key="category.key" class="category-item"
					:class="{ 'active': activeCategory === category.key }" @click="switchCategory(category.key)">
					{{ category.name }}
				</div>
			</div>
			<div class="menuBox">
				<div class="record" @click="dialogRecordViable = true">
					明细列表
				</div>
				<div class="exchange" @click="exchangeCoupon">
					兑换码兑换
				</div>
			</div>
		</div>
		<div class="voucherList" v-if="voucherData.length">
			<div class="voucherItem" v-for="(item,index) in voucherData" :key="index">
				<img class="bgIcon" src="../assets/BuyNow/iconK.png" v-if="item.status == 1 && item.out_status == 1" />
				<img class="bgOtherIcon" src="../assets/BuyNow/iconL.png" v-else />
				<div class="price">
					<span class="unit" v-if="item.v_type == 1">¥</span>
					{{item.v_type == 1 ? (item.original_price * 1).toFixed(0) : (onAmountInput(item) + '折')}}
				</div>
				<div class="couponInfp">
					<div class="desc">
						{{item.v_type == 1 ? `满${item.max_price}减${item.original_price}` : `满${item.max_price}可使用`}}
					</div>
					<div class="type">全场通用</div>
					<div class="day">剩余{{item.end_time}}天</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-else></el-empty>
		<el-dialog class="recordDialog" :visible.sync="dialogRecordViable" append-to-body
			@close="dialogRecordViable = false" @open="voucherMoneyList">
			<div slot="title">
				<div class="dislogTitle">
					明细列表
				</div>
			</div>
			<div class="dislogConent">
				<div class="recordList" v-if="recordData.length">
					<div class="recordItem" v-for="(item,index) in recordData" :key="index">
						<div class="recordItemLeft">
							<div class="recordItemTile">
								{{item.content}}
							</div>
							{{item.create_time}}
						</div>
						{{item.price > 0 ? ( '+ ' + item.price) : item.price}}
					</div>
				</div>
				<el-empty description="暂无数据" v-else></el-empty>
			</div>
		</el-dialog>
		<el-dialog class="phoneDialog" :visible="phoneShow" append-to-body
			@close="phoneShow = false;exchangeVocher = {};ruleForm.num = ''">
			<div slot="title">
				<div class="dislogTitle">
					兑换码兑换
				</div>
			</div>
			<div class="dislogConent">
				<el-form ref="phoneRuleForm" hide-required-asterisk :model="ruleForm" :rules="rules">
					<el-form-item label="温馨提示：" prop="phone">
						<div class="form-group"
							style="width: 4.2rem;font-weight: 500;font-size: .14rem;color: #312C28;line-height: .22rem;">
							请您输入正确且未激活，有效期正常的兑换码，输入后，先点击“立即校验”操作，
							然后核实兑换码可兑换的代金券信息无误后，进行兑换。如有问题，请联系平台客服。
						</div>
					</el-form-item>
					<el-form-item label="兑换码：" prop="num">
						<div class="form-group" style="width: 4.2rem;">
							<div class="verification-container">
								<input type="text" style="width: 3rem;flex: 1;" v-model="ruleForm.num"
									placeholder="请输入您的兑换码" class="verification-input" @input="exchangeVocher = {}" />
								<span v-if="showVerificationError" class="error-message">{{errorMsg}}</span>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="代金券：" prop="phone" v-if="exchangeVocher.id">
						<div class="form-group" style="width: 4.2rem;">
							<div class="voucherItem">
								<img class="bgIcon" src="../assets/BuyNow/iconK.png" />
								<div class="price">
									<span class="unit" v-if="exchangeVocher.type == 1">¥</span>
									{{exchangeVocher.type == 1 ? (exchangeVocher.original_price * 1).toFixed(0) : (onAmountInput(exchangeVocher) + '折')}}
								</div>
								<div class="couponInfp">
									<div class="desc">
										{{exchangeVocher.type == 1 ? `满${exchangeVocher.max_price}减${exchangeVocher.original_price}` : `满${exchangeVocher.max_price}可使用`}}
									</div>
									<div class="type">全场通用</div>
									<div class="day">剩余{{exchangeVocher.day}}天</div>
								</div>
							</div>
						</div>
					</el-form-item>
					<el-form-item label="兑换数量：" prop="phone" v-if="exchangeVocher.id">
						<div class="form-group"
							style="width: 4.2rem;font-weight: 500;font-size: .14rem;color: #312C28;line-height: .22rem;">
							{{exchangeVocher.dh_count}}
						</div>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer">
				<div class="menuBox">
					<el-button class="submit" type="primary" size="medium" @click="submitExchangeForm('phoneRuleForm')"
						v-if="exchangeVocher.id">立即兑换</el-button>
					<el-button class="submit" type="primary" size="medium" @click="submitPhoneForm('phoneRuleForm')"
						v-else>立即校验</el-button>
				</div>
			</div>
		</el-dialog>
		<PopToast :imgPtahUrl="require('@/assets/Feedback/sucIcon.png')" :desc="'兑换成功'" @clickOk="sucPop = false;"
			v-if="sucPop" />
	</div>
</template>

<script>
	import PopToast from '../components/PopToast.vue'
	export default {
		name: 'MyVoucher',
		components: {
			PopToast,
		},
		data() {
			return {
				// 分类导航
				categories: [{
						key: '',
						name: '全部'
					},
					{
						key: '1',
						name: '可用'
					},
					{
						key: '2',
						name: '已使用'
					},
					{
						key: '3',
						name: '已过期'
					}
				],
				sucPop: false,
				activeCategory: '',
				voucherData: [],
				recordData: [],
				phoneShow: false,
				exchangeVocher: {},
				errorMsg: '',
				dialogRecordViable: false,
				showVerificationError: false,
				ruleForm: {
					num: '',
				},
				rules: {
					num: [{
						required: true,
						message: '请输入您的兑换码',
						trigger: 'blur'
					}],
				}
			}
		},
		mounted() {
			this.voucherUserList()
			this.voucherMoneyList()
		},
		methods: {
			onAmountInput(item) {
				let val = item.original_price;
				// ① 去掉非数字和小数点
				val = val.replace(/[^\d.]/g, "");

				// ② 如果以 0 开头且第二位不是小数点 → 去掉前导 0
				if (/^0\d+/.test(val)) {
					val = val.replace(/^0+/, "");
				}

				// ③ 开头是 "." → 自动补 0
				if (val.startsWith(".")) {
					val = "0" + val;
				}

				// ④ 只留一个小数点
				val = val.replace(/\.{2,}/g, ".");
				val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");

				// ⑤ 限制两位小数
				val = val.replace(/^(\d+)\.(\d{0,2}).*$/, "$1.$2");

				// ⑥ 处理格式化逻辑：去掉无意义的小数
				if (val.includes(".")) {

					// 去掉结尾的 .
					if (val.endsWith(".")) {
						val = val.slice(0, -1);
					}

					// 去掉末尾多余的 0 （例如 9.50 → 9.5 | 9.00 → 9）
					val = val.replace(/(\.\d*?)0+$/, "$1"); // 去掉小数后多余0
					val = val.replace(/\.$/, ""); // 全是0时去掉小数点

					// 若变成 "9." 或 "9.0" 再精简
					if (/^\d+\.$/.test(val)) {
						val = val.replace(/\.$/, "");
					}
					if (/^\d+\.0+$/.test(val)) {
						val = val.replace(/\.0+$/, "");
					}
				}
				return val
			},
			// 切换分类
			switchCategory(category) {
				this.activeCategory = category;
				this.voucherUserList()
			},
			voucherUserList() {
				this.$api.post('OrderIntegral/voucher_user_list', {
					status: this.activeCategory
				}).then(res => {
					if (res.code == 1) {
						this.categories[0].name =
							`全部（${(res.data.ky_count ? res.data.ky_count : 0) + (res.data.yy_count ? res.data.yy_count : 0) + (res.data.gq_count ? res.data.gq_count : 0)}）`
						this.categories[1].name = `可用 (${res.data.ky_count ? res.data.ky_count : 0})`
						this.categories[2].name = `已使用 (${res.data.yy_count ? res.data.yy_count : 0})`
						this.categories[3].name = `已过期 (${res.data.gq_count ? res.data.gq_count : 0})`
						this.voucherData = res.data.list
					}
				}).catch(err => {
					console.log(err);
				})
			},
			voucherMoneyList() {
				this.$api.post('UserD/voucher_money_list', {}).then(res => {
					if (res.code == 1) {
						this.recordData = res.data
					}
				}).catch(err => {
					console.log(err);
				})
			},
			submitPhoneForm(formName) { //75183024350932
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('UserD/user_duihuan_details', {
							num: this.ruleForm.num
						}).then(res => {
							if (res.code == 1) {
								this.errorMsg = ''
								this.showVerificationError = false
								this.exchangeVocher = res.data
							} else {
								this.errorMsg = res.msg
								this.showVerificationError = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			submitExchangeForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.$api.post('UserD/user_duihuan', {
							num: this.ruleForm.num
						}).then(res => {
							if (res.code == 1) {
								this.voucherUserList()
								this.phoneShow = false
								this.sucPop = true
							}
						}).catch(err => {
							console.log(err);
						})
					} else {
						return false
					}
				})
			},
			exchangeCoupon() {
				this.phoneShow = true
			},

		}
	}
</script>

<style lang="scss" scoped>
	.myOrderContainer {
		display: flex;
		flex-direction: column;
		padding: .24rem .4rem;
	}

	/* 消息分类导航样式 */
	.msg-center-nav {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: .01rem solid rgba(204, 204, 204, .4);
	}

	.menuBox {
		display: flex;
		align-items: center;

		.record {
			width: .76rem;
			height: .32rem;
			background: #EFD8B8;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .12rem;
			color: #252525;
			text-align: center;
			line-height: .32rem;
			cursor: pointer;
		}

		.exchange {
			margin-left: .16rem;
			width: .88rem;
			height: .32rem;
			background: #E29358;
			border-radius: .04rem;
			font-weight: 500;
			font-size: .12rem;
			color: #252525;
			text-align: center;
			line-height: .32rem;
			cursor: pointer;
		}
	}

	.msg-categories {
		display: flex;
		gap: .32rem;
	}

	.category-item {
		font-weight: 400;
		font-size: .16rem;
		color: #040404;
		cursor: pointer;
		padding: .24rem 0 .15rem;
		position: relative;
		transition: color 0.3s ease;
	}

	.category-item:hover {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item.active {
		font-weight: 500;
		font-size: .16rem;
		color: #6B3503;
	}

	.category-item::after {
		content: '';
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: .02rem;
		background-color: #693200;
		transform: scaleX(0);
		transform-origin: left center;
		transition: transform 0.3s ease;
	}

	.category-item.active::after {
		transform: scaleX(1);
	}


	.voucherList {
		margin-top: .16rem;
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		overflow-y: auto;

		.voucherItem:nth-child(3n) {
			margin-right: 0;
		}

		.voucherItem {
			margin-right: .16rem;
			margin-top: .16rem;
			width: 2.7rem;
			height: .92rem;
			display: flex;
			align-items: center;
			cursor: pointer;
			position: relative;

			.bgIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: 2.70;
				height: .92rem;
			}

			.bgOtherIcon {
				position: absolute;
				top: 0;
				left: 0;
				width: 2.70;
				height: .92rem;
				z-index: 2;
			}

			.price {
				width: .92rem;
				display: flex;
				align-items: baseline;
				justify-content: center;
				font-weight: 700;
				font-size: .34rem;
				color: #000000;
				z-index: 1;

				.unit {
					font-weight: 400;
					font-size: .14rem;
				}
			}

			.couponInfp {
				margin-left: .16rem;
				display: flex;
				flex-direction: column;
				z-index: 1;

				.desc {
					font-weight: 700;
					font-size: .14rem;
					color: #000000;
					line-height: .2rem;
				}

				.type {
					margin-top: .04rem;
					font-weight: 400;
					font-size: .12rem;
					color: rgba(0, 0, 0, .7);
				}

				.day {
					font-weight: 400;
					font-size: .11rem;
					color: #000000;
				}
			}
		}
	}

	.recordDialog {
		::v-deep .el-dialog {
			width: 5.4rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				display: flex;
				flex-direction: column;
				align-items: center;
				padding: 0 .24rem .24rem;
				font-weight: 400;
				font-size: .14rem;
				color: #252525;
				width: 5.4rem;

				.dislogConent {
					width: 100%;
				}

				.recordList {
					display: flex;
					flex-direction: column;
					max-height: 5rem;
					width: 100%;
					overflow-y: auto;

					.recordItem {
						height: .7rem;
						display: flex;
						align-items: center;
						justify-content: space-between;
						padding: .12rem .12rem;
						font-weight: 500;
						font-size: .16rem;
						color: #E29358;
						border-bottom: .01rem solid #CCCCCC;

						.recordItemLeft {
							display: flex;
							flex-direction: column;
							font-weight: 400;
							font-size: .12rem;
							color: #73767C;

							.recordItemTile {
								font-weight: 400;
								font-size: .16rem;
								color: #161616;
							}
						}
					}
				}
			}
		}
	}

	.phoneDialog {
		::v-deep .el-dialog {
			width: 5.4rem;
			border-radius: .12rem;

			&__header {
				padding: .24rem .24rem;

				.dislogTitle {
					font-weight: 500;
					font-size: .18rem;
					color: #252525;
				}
			}

			&__body {
				padding: 0 .24rem;

				.form-group {
					// margin-top: .16rem;
				}

				.voucherItem {
					width: 2.7rem;
					height: .92rem;
					display: flex;
					align-items: center;
					cursor: pointer;
					position: relative;

					.bgIcon {
						position: absolute;
						top: 0;
						left: 0;
						width: 2.70;
						height: .92rem;
					}

					.bgOtherIcon {
						position: absolute;
						top: 0;
						left: 0;
						width: 2.70;
						height: .92rem;
						z-index: 2;
					}

					.price {
						width: .92rem;
						display: flex;
						align-items: baseline;
						justify-content: center;
						font-weight: 700;
						font-size: .34rem;
						color: #000000;
						z-index: 1;

						.unit {
							font-weight: 400;
							font-size: .14rem;
						}
					}

					.couponInfp {
						margin-left: .16rem;
						display: flex;
						flex-direction: column;
						z-index: 1;

						.desc {
							font-weight: 700;
							font-size: .14rem;
							color: #000000;
							line-height: .2rem;
						}

						.type {
							margin-top: .06rem;
							font-weight: 400;
							font-size: .12rem;
							color: rgba(0, 0, 0, .7);
							line-height: .18rem;
						}

						.day {
							margin-top: .04rem;
							font-weight: 400;
							font-size: .11rem;
							color: #000000;
							line-height: .16rem;
						}
					}
				}

				// 手机号和验证码输入框样式
				.phone-input-container,
				.verification-container,
				.invite-container {
					width: 100%;
					height: 0.44rem;
					border: .01rem solid #EFD8B8;
					border-radius: 0.04rem;
					padding: 0 0.16rem;
					font-size: 0.14rem;
					color: #333333;
					outline: none;
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.phone-input,
				.verification-input,
				.invite-input {
					border: none;
					outline: none;
					padding: 0 0;

					font-size: 0.14rem;
					color: #333333;

					&::placeholder {
						color: #999999;
					}
				}

				.get-code-btn {
					padding: 0 0;
					color: #E29358;
					font-size: 0.14rem;
					cursor: pointer;

					&:disabled {
						background: #FFFFFF;
						color: #CCCCCC;
						border-color: #CCCCCC;
						cursor: not-allowed;
					}
				}

				// 错误提示样式
				.error-message {
					background: #F56C6C;
					padding: 0.04rem 0.09rem;
					border-radius: 0.02rem;
					font-weight: 400;
					font-size: 0.12rem;
					color: #FFFFFF;
					line-height: .22rem;
				}


				.el-form {
					&-item:nth-child(1) {
						align-items: flex-start;
					}

					&-item {
						display: flex;
						align-items: center;
						margin-bottom: .24rem;

						&__label {
							padding: 0 0;
							width: .7rem;
							font-size: .14rem;
							color: #252525;
							line-height: .2rem;
						}

						&__error {
							font-size: .12rem;
							padding-top: .04rem;
						}

						&__content {

							.el-input {

								&__inner {
									width: 4.1rem;
									height: .52rem;
									font-weight: 400;
									font-size: .14rem;
									color: #252525;
									line-height: .52rem;
									border: .01rem solid #EFD8B8;
								}

								&__icon {
									font-size: .14rem;
								}
							}
						}
					}
				}
			}

			&__footer {
				padding: .08rem .24rem .24rem;

				.menuBox {
					display: flex;
					align-items: center;
					justify-content: center;

					.submit {
						margin: 0 auto;
						width: 1.3rem;
						height: .36rem;
						background: #E29358;
						border-radius: .04rem;
						padding: 0 0;
						font-weight: 400;
						font-size: .14rem;
						color: #252525;
						text-align: center;
						line-height: .36rem;
						border: none;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>